import React, { useState } from 'react';
import { Button, message } from 'antd';
import OrderListTemplate from '../components/OrderListTemplate';
import { MergedOrder, OrderTabScene } from '../../../types/process/order';
import OrderTriggerActionMap, { OrderTriggerActionProvider, type OrderTriggerTarget } from '../components/OrderTriggerActionMap';
import { useDefaultQueryFields } from '../order.effect';
import TransferOrderModal from '../components/modals/TransferOrderModal';

const DClassCancelList: React.FC = () => {
  const tabScene = OrderTabScene.GroupTeamAuditDClassCancel;
  const queryFields = useDefaultQueryFields(tabScene);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<MergedOrder[]>([]);
  const [isTransferModalVisible, setIsTransferModalVisible] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const renderTableActions = (order: MergedOrder) => {
    const targets: OrderTriggerTarget[] = ['reportView'];

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Button 
          type="link" 
          onClick={() => {
            setSelectedRows([order]);
            setIsTransferModalVisible(true);
          }}
          style={{ padding: 0, height: 'auto' }}
        >
          指派审核
        </Button>
        <OrderTriggerActionMap layout="list" targets={targets} order={order} />
      </div>
    );
  };

  const handleBatchTransfer = () => {
    if (selectedRows.length === 0) {
      message.warning('请先选择订单');
      return;
    }
    setIsTransferModalVisible(true);
  };

  return (
    <OrderTriggerActionProvider onReload={() => setRefreshKey(k => k + 1)}>
      <OrderListTemplate
        refreshKey={refreshKey}
        tabScene={tabScene}
        defaultScene='tab_team_audit_d_class_cancel'
        queryFields={queryFields}
        batchActionNode={
          <Button type="primary" onClick={handleBatchTransfer} disabled={selectedRows.length === 0}>
            批量指派 ({selectedRows.length})
          </Button>
        }
        viewModes={[
          {
            mode: 'table',
            label: '表格页',
            showField: 'preAudit',
            rowSelection: {
              selectedRowKeys,
              onChange: (newSelectedRowKeys: React.Key[], newSelectedRows: MergedOrder[]) => {
                setSelectedRowKeys(newSelectedRowKeys);
                setSelectedRows(newSelectedRows);
              },
            },
            renderActions: renderTableActions,
          },
          {
            mode: 'list',
            label: '产品页',
            renderActions: renderTableActions,
          },
        ]}
      />
      {isTransferModalVisible && (
        <TransferOrderModal
          visible={isTransferModalVisible}
          orders={selectedRows}
          actionType='dispatch_d_class'
          onCancel={() => setIsTransferModalVisible(false)}
          onSuccess={() => {
            setIsTransferModalVisible(false);
            setSelectedRowKeys([]);
            setSelectedRows([]);
            setRefreshKey((k) => k + 1);
          }}
        />
      )}
    </OrderTriggerActionProvider>
  );
};

export default DClassCancelList;
